import { faArrowUpArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps } from '@mui/material';
import { StyledDiv } from './shared-drawer.styles';

interface OrganizeRequestButtonProps extends ButtonProps {
  mt: number;
  onClick: () => void;
  disabled?: boolean;
  isContextReady?: boolean;
}

export const OrganizeRequestButton = ({
  mt = 48,
  onClick,
  disabled = false,
  isContextReady = true,
}: OrganizeRequestButtonProps) => {
  return (
    <StyledDiv
      data-cy="organize-requests-stack"
      mt={mt}
      $opaque={!isContextReady}
    >
      <Button
        variant="outlined"
        color="tertiary"
        size="small"
        onClick={onClick}
        disabled={disabled}
        data-cy="organize-requests-btn"
        startIcon={<FontAwesomeIcon icon={faArrowUpArrowDown} />}
      >
        Organize Requests
      </Button>
    </StyledDiv>
  );
};
